import { render, staticRenderFns } from "./ColumnComponent.vue?vue&type=template&id=db0b7e4a&scoped=true&"
import script from "./ColumnComponent.vue?vue&type=script&lang=js&"
export * from "./ColumnComponent.vue?vue&type=script&lang=js&"
import style0 from "./ColumnComponent.vue?vue&type=style&index=0&id=db0b7e4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0b7e4a",
  null
  
)

export default component.exports